import type { PaymentMethod } from "../types";

export type PaymentMethodStatus = "expired" | "expiring" | "ok";

const EXPIRING_WINDOW_DAYS = 30;
const DAY_IN_MS = 24 * 60 * 60 * 1000;

export function paymentMethodStatus(
  method: PaymentMethod,
  today: Date = new Date(),
): PaymentMethodStatus {
  if (method.type !== "card") return "ok";

  const firstInvalidDay = new Date(method.expiryYear, method.expiryMonth, 1);
  const msUntilInvalid = firstInvalidDay.getTime() - today.getTime();

  if (msUntilInvalid <= 0) return "expired";
  if (msUntilInvalid <= EXPIRING_WINDOW_DAYS * DAY_IN_MS) return "expiring";

  return "ok";
}
